module.exports = __webpack_public_path__ + "img/favicon.68852ff1.png";